<form [formGroup]="suitprogressForm">
    <div class="the_card report_progress">
    <div class="top_form">
      <div class="forms">
        <div class="the_input">
          <label for="">Progress Remark</label>
          <textarea name="" id="" cols="60" rows="5" class="default_input" formControlName="ProgressRemarks"></textarea>
        </div>

        <div class="the_input mt-4">
          <label for="">Suit Progress Status</label>
          <select class="default_input" formControlName="SuitStatus">                           
            <option value="PENDING">PENDING</option>
            <option value="CLOSED">CLOSED</option>
            <option value="UNRESOLVED">UNRESOLVED</option>
        </select>
        </div>

        <div class="the_input mb-1">
          <label for="">Progress Date</label>
          <input type="date" name="" id="" class="default_input" formControlName="ProgressDate"/>
        </div>
      </div>

      <div class="btn_hold">
        <button class="default_primary-button" *ngIf="selectedSuitProgresss" (click)="onSubmit(suitprogressForm.value)">Save</button>
      </div>
    </div>
    <div class="table_display">
      <div class="the_head">
        <span class="head_item">S/N</span>
        <span class="head_item"> Progress Remarks</span>
        <span class="head_item">Progress Date</span>
        <span class="head_item">Status</span>
        <span class="head_item">Delete</span>
      </div>
      <div class="the_row" *ngFor="
      let progress of selectedSuitProgresss?.suitProgress;
      index as i
    ">
        <span class="row_item">{{ i + 1 }}</span>
        <span class="row_item">{{progress.ProgressRemarks}}</span>
        <span class="row_item">{{progress.ProgressDate | date}}</span>
        <span class="row_item">{{progress.SuitStatus}}</span>
        <em class="ti-trash" style="cursor: hand;" (click)="onDelete(i, progress.value)"> </em> 
      </div>
    </div>


    <!-- <div class="table_display">
      <div class="the_head">
        <span class="head_item">S/N</span>
        <span class="head_item">Progress Remarks</span>
        <span class="head_item">Progress Date</span>
        <span class="head_item">Status</span>
        <span class="head_item">Delete</span>
      </div>
      <div class="the_row" *ngFor="
      let progress of selectedSuitProgresss?.suitProgress;
      index as i
    ">
        <span class="row_item">{{ i + 1 }}</span>
        <span class="row_item">{{progress.ProgressRemarks}}</span>
        <span class="row_item">{{progress.ProgressDate | date}}</span>
        <span class="row_item">{{progress.SuitStatus}}</span>
        <span class="row_item">
            <em class="ti-trash" (click)="onDelete(i, progress.value)"> </em> 
        </span>
      </div>
    </div> -->
    </div>
   </form>



<!-- 
<div class="reference_body">
    <main class="reference_main">
    <form  [formGroup]="suitprogressForm">
        <div class="row">
            <div class="col-md-5">
                <div class="row">
                    <div class="parameter_contained col-lg-10">
                        <label for="" style="display:block;">Progress Remarks</label>
                        <div class="search">
                            <input type="text" name="search" id="nav_search"
                                    placeholder="Enter progress remarks" formControlName="ProgressRemarks">
                        </div>
                        
                    </div>
                </div>
                <div class="row">
                    <div class="parameter_contained col-lg-10">
                        <label for="" style="display:block;">Progress Date</label>
                        <div class="search">
                            <input type="date" name="search" id="nav_search"
                                            placeholder="Enter Progress Date" formControlName="ProgressDate">
                        </div>
                    </div>
                </div>
                
                
            </div>
            
            <div class="col-md-5">
                <div class="row">
                    <div class="parameter_contained col-lg-12">
                        <label for="" style="display:block;">Suit Progress Status:</label>
                        <div class="search">
                            <select style='width:100%' formControlName="SuitStatus">                           
                                <option value="PENDING">PENDING</option>
                                <option value="CLOSED">CLOSED</option>
                                <option value="UNRESOLVED">UNRESOLVED</option>
                            </select>
                        </div>
                     
                    </div>
                </div>
                <div class="row">
                    <div class="the_button col-lg-12">
                        <button class="next" *ngIf="selectedSuitProgresss" (click)="onSubmit(suitprogressForm.value)">Submit</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-11">
                <div class="custom_table_four_row">
                      <div class="thead">
                        <span class="head">S/N</span>
                        <span class="head">Progress Remarks</span>
                        <span class="head">Progress Date</span>
                        <span class="head">Status</span>
                        <span class="head"></span>
                      </div>
              
                      <div class="tbody">
                        <div
                          class="td"
                          *ngFor="
                            let progress of selectedSuitProgresss?.suitProgress;
                            index as i
                          "
                        >
                          <span class="head">{{ i + 1 }}</span>
                          <span
                            >{{progress.ProgressRemarks}}</span>
                          <span
                            >{{progress.ProgressDate | date}}</span>
                          <span
                            >{{progress.SuitStatus}}</span>
                          <button
                              class="delete_icon trash"
                              (click)="onDelete(i, progress.value)"
                            >
                              <em class="ti-trash"> </em> </button
                          >
                        </div>
                      </div>
              
                  </div>

            </div>
        </div>

    </form>
    </main>
</div> -->